import { InjectionToken } from '@angular/core';

export interface AttachmentsHandlerConfig {
    apiBaseUrl: string;
    apiUrl: string;
    gridSystemEnabled?: boolean;
}

export const ATTACHMENTS_HANDLER_CONFIG = new InjectionToken<AttachmentsHandlerConfig>('ATTACHMENTS_HANDLER_CONFIG');
